<div class="content-nav">
  <a href="javascript:;" class="side-menu_expand" (click)="menuExpandActive()" #menuExpand>Menus</a>
  <ul class="side-nav-list" #ulExpand>
    <li class="liCursor" [attr.title]=item.text (click)="listClick($event,item.value, item.link)"
      [ngClass]="(selectedItem==item.value)?'active':''" *ngFor="let item of listElements">
      <a>{{ item.text }}</a>
    </li>
  </ul>
</div>